export enum SidepanelModeEnum {
  form,
  termsAndConditions
}
